<template>
	<u-banner v-if="unit.control_code == 'banner'"></u-banner>
	<u-menu v-else-if="unit.control_code == 'cell_icon'"></u-menu>
	<u-product v-else-if="unit.control_code == 'product'"></u-product>
	<u-scroll-image v-else-if="unit.control_code == 'roll_icon'"></u-scroll-image>
	<u-image-advert v-else-if="unit.control_code == 'img_advert'"></u-image-advert>
	<u-link-area v-else-if="unit.control_code == 'link_area'"></u-link-area>
	<u-blank v-else-if="unit.control_code == 'separator'"></u-blank>
	<u-recommend-product v-else-if="unit.control_code == 'waterfall_flow'"></u-recommend-product>
	<u-channel-banner v-else-if="unit.control_code == 'channel_banner'"></u-channel-banner>
	<u-channel-product v-else-if="unit.control_code == 'channel_product'"></u-channel-product>
</template>

<script>
	import unitHandle from './unit_handle.vue'
	import uBanner from './unit/app/banner.vue'
	import uMenu from './unit/app/menu.vue'
	import uProduct from './unit/app/product.vue'
	import uScrollImage from './unit/app/scroll_image.vue'
	import uImageAdvert from './unit/app/image_advert.vue'
	import uLinkArea from './unit/link_area.vue'
	import uBlank from './unit/app/blank'
	import uRecommendProduct from './unit/app/recommend_product.vue'
	import uChannelBanner from './unit/app/channel_banner.vue'
	import uChannelProduct from './unit/app/channel_product.vue'
	
	export default {
		components: {
			unitHandle,
			uBanner,
			uMenu,
			uProduct,
			uScrollImage,
			uImageAdvert,
			uLinkArea,
			uBlank,
			uRecommendProduct,
			uChannelBanner,
			uChannelProduct
		},
		
		props: {
			unit: Object
		}
	}
</script>

<style>
</style>
